import React from 'react';
import CapexCaptureWidgetRenderer from './CapexCaptureWidgetRenderer';

const Preview: React.FC = () => <CapexCaptureWidgetRenderer config={{}} />;

export default Preview;
